import moment from 'moment';

const FormatDate = (date: string): string => {
  return moment(date).format('DD-MMM-YYYY');
};

export default FormatDate;
